import { render, staticRenderFns } from "./ReportsWidget.vue?vue&type=template&id=726ddb44"
import script from "./ReportsWidget.vue?vue&type=script&lang=js"
export * from "./ReportsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports